import React from "react";
import { useSelector } from "react-redux";

import QnAIcon from "../../../assets/images/icons/qna_mode.svg";
import AccessCodeIcon from "../../../assets/images/icons/access_code.svg";
import { AuthMethodDialogConstants } from "src/Core/Common/Constants";
import { AuthenticationMethod } from "src/Core/Common/Enums";
import AuthMethodCard from "./AuthMethodCard";
import { ApplicationState } from "src/store";
import { logger } from "src/routes/LoggedIn";
import { appInsightsData } from "src/helper/AppInsightsData";
interface IAuthMethodSelectProps {
    defaultAuthMethod: AuthenticationMethod;
    activeAuthMethod: AuthenticationMethod;
    onAuthMethodClick: (authMethod: AuthenticationMethod) => void;
    onSetDefaultClick: (e: any, authMethod: AuthenticationMethod) => void;
}

const AuthMethodSelect: React.FC<IAuthMethodSelectProps> = props => {
    const authenticationSettings = useSelector(
        (state: ApplicationState) => state.adminSettingsState.messageOptions.authenticationSettings
    );

    const handleOnCardClick = (method: number, eventName: string) => {
        props.onAuthMethodClick(method);
        logger.trackEvent({
            name: `${appInsightsData.Compose.AuthMethod.pageTitle} - ${eventName}`,
            properties: {
                page: appInsightsData.Compose.AuthMethod.pageTitle,
                authMetho: method
            }
        });
    };

    return (
        <div className="dialog-body flex-row">
            <AuthMethodCard
                disabled={!authenticationSettings.authenticationMethods.includes(AuthenticationMethod.QUESTIONANSWER)}
                authMethod={AuthenticationMethod.QUESTIONANSWER}
                cardTitle={AuthMethodDialogConstants.QNA_CARD_TITLE}
                cardImage={QnAIcon}
                isDefault={props.defaultAuthMethod === AuthenticationMethod.QUESTIONANSWER}
                isActive={props.activeAuthMethod === AuthenticationMethod.QUESTIONANSWER}
                allowToChangeDefaultMethod={authenticationSettings.allowEmployeesToChangeDefaultMethod}
                onMethodClick={() =>
                    authenticationSettings.allowEmployeesToChangeAuthMethod &&
                    handleOnCardClick(AuthenticationMethod.QUESTIONANSWER, appInsightsData.Compose.Operation.QnASelected)
                }
                onSetDefaultClick={props.onSetDefaultClick}
            />
            <AuthMethodCard
                disabled={!authenticationSettings.authenticationMethods.includes(AuthenticationMethod.ACCESSCODE)}
                authMethod={AuthenticationMethod.ACCESSCODE}
                cardTitle={AuthMethodDialogConstants.ACCESS_CODE_CARD_TITLE}
                cardImage={AccessCodeIcon}
                isDefault={props.defaultAuthMethod === AuthenticationMethod.ACCESSCODE}
                isActive={props.activeAuthMethod === AuthenticationMethod.ACCESSCODE}
                allowToChangeDefaultMethod={authenticationSettings.allowEmployeesToChangeDefaultMethod}
                onMethodClick={() =>
                    authenticationSettings.allowEmployeesToChangeAuthMethod &&
                    handleOnCardClick(AuthenticationMethod.ACCESSCODE, appInsightsData.Compose.Operation.AccessCodeSelected)
                }
                onSetDefaultClick={props.onSetDefaultClick}
            />
        
            {/* <AuthMethodCard
                disabled={!authenticationSettings.authenticationMethods.includes(AuthenticationMethod.LOGINPASSWORD)}
                authMethod={AuthenticationMethod.LOGINPASSWORD}
                cardTitle={AuthMethodDialogConstants.LOGIN_CARD_TITLE}
                cardImage={LoginModeLogo}
                isDefault={props.defaultAuthMethod === AuthenticationMethod.LOGINPASSWORD}
                isActive={props.activeAuthMethod === AuthenticationMethod.LOGINPASSWORD}
                allowToChangeDefaultMethod={authenticationSettings.allowEmployeesToChangeDefaultMethod}
                onMethodClick={() =>
                    authenticationSettings.allowEmployeesToChangeAuthMethod &&
                    props.onAuthMethodClick(AuthenticationMethod.LOGINPASSWORD)
                }
                onSetDefaultClick={props.onSetDefaultClick}
            /> */}
        </div>
    );
};

export default AuthMethodSelect;
